import {
    MEDIA_CONTENT_IMAGE,
    MEDIA_CONTENT_PDF,
    LAST_MODIFIED_FILE,
} from './threads';

export const DOCUMENT_TITLES = [
    'Quote',
    'TechnicalSheet',
    'CreditsRequirements',
    'MaintenanceCosts',
    'Location',
    'GalleryVersions',
    'CreditRequest',
];

export const DOCUMENT_QUOTE = 'Quote';
export const DOCUMENT_TECHNICAL_SHEET = 'TechnicalSheet';
export const DOCUMENT_CATALOGUE = 'Catalogue';
export const DOCUMENTS_TEXT_IN_TRANSLATIONS = 'Documents.';
export const DOCUMENT_QUOTE_DESCRIPTION = 'para cliente';
export const DOCUMENT_CATALOGUE_DESCRIPTION = 'versión digital';
export const DOCUMENT_ID_DEFAULT = 'doc1';
export const DOCUMENT_MAKE_DEFAULT = 'Toyota';
export const DOCUMENT_MODEL_DEFAULT = 'Corolla';

export const DEFAULT_DOCUMENT = { title: '', file: '' };

export const IMAGE_TEST_FILE = new File(['test'], 'test.jpg', {
    type: MEDIA_CONTENT_IMAGE,
});

export const PDF_FILE_NAME = 'documento1.pdf';

export const PDF_TEST_FILE = new File(['contenido'], PDF_FILE_NAME, {
    type: MEDIA_CONTENT_PDF,
    lastModified: LAST_MODIFIED_FILE,
});

export const DOCUMENT_ONE = 'Document one';
export const DOCUMENT_TWO = 'Document two';
export const SELECT_DOCUMENTATION = 'Select Documentation';
export const STORE_ID_DEFAULT = 'storeId';

export const DIALOG_ROLE = 'dialog';
export const DIALOG_KEY_DOWN = 'Escape';
export const BUTTON_ROLE = 'button';

export const IMAGE_ICON_NAME = 'comments';

export const DOCUMENTS_TRANSLATIONS = {
    'Documents.DocumentOne': DOCUMENT_ONE,
    'Documents.DocumentTwo': DOCUMENT_TWO,
    'Buttons.SelectDocumentation': SELECT_DOCUMENTATION,
};
